(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-commerce-blocks"]) return;
  try {
    
  (function () {
    function moveArticleCommerce() {
      var commerceBlock = document.querySelector('.article-commerce');
      var articleContent = document.querySelector('.article-template__content');

      if (!commerceBlock || !articleContent) {
        return;
      }

      if (commerceBlock.previousElementSibling !== articleContent) {
        articleContent.insertAdjacentElement('afterend', commerceBlock);
      }
    }

    function classifyInlineProductGrids() {
      var articleContent = document.querySelector('.article-template__content');

      if (!articleContent) {
        return;
      }

      var grids = articleContent.querySelectorAll('div[style*="grid-template-columns"][style*="auto-fit"]');

      grids.forEach(function (grid) {
        var cards = Array.prototype.filter.call(grid.children, function (child) {
          return child.querySelector && child.querySelector('a[href*="/products/"]');
        });

        if (!cards.length) {
          return;
        }

        grid.classList.add('blog-inline-product-grid');
        grid.classList.add('blog-inline-product-grid--count-' + cards.length);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        moveArticleCommerce();
        classifyInlineProductGrids();
        window.setTimeout(classifyInlineProductGrids, 250);
      });
    } else {
      moveArticleCommerce();
      classifyInlineProductGrids();
      window.setTimeout(classifyInlineProductGrids, 250);
    }

    document.addEventListener('shopify:section:load', function () {
      moveArticleCommerce();
      classifyInlineProductGrids();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-language-polish"]) return;
  try {
    
  (function () {
    function setLinkText(link, text) {
      if (!link) {
        return;
      }

      var icon = link.querySelector('svg, .icon');
      link.textContent = '';

      if (icon) {
        link.appendChild(icon);
      }

      link.appendChild(document.createTextNode(' ' + text));
      link.setAttribute('aria-label', text);
    }

    function polishArticleLanguage() {
      setLinkText(document.querySelector('.article-template__link'), 'Back to dog advice');

      document.querySelectorAll('a').forEach(function (link) {
        var label = link.textContent.trim();

        if (label === 'Read more') {
          link.textContent = 'Read the guide';
        }

        var ariaLabel = link.getAttribute('aria-label');
        if (ariaLabel && ariaLabel.indexOf('Read more:') === 0) {
          link.setAttribute('aria-label', ariaLabel.replace('Read more:', 'Read the guide:'));
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', polishArticleLanguage);
    } else {
      polishArticleLanguage();
    }

    document.addEventListener('shopify:section:load', polishArticleLanguage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chew-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const emit = (finder, action, detail = {}) => {
      const payload = { action, section_id: finder.closest('.shopify-section')?.id || '', ...detail };
      finder.dispatchEvent(new CustomEvent('chew-finder:event', { bubbles: true, detail: payload }));
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'chew_finder', ...payload });
    };

    const list = (value) => value.split(',').filter(Boolean);

    const initialise = (finder) => {
      if (finder.dataset.initialised === 'true') return;
      finder.dataset.initialised = 'true';
      finder.classList.add('is-enhanced');

      const form = finder.querySelector('[data-finder-form]');
      const steps = [...finder.querySelectorAll('[data-step]')];
      const start = finder.querySelector('[data-finder-start]');
      const back = finder.querySelector('[data-finder-back]');
      const next = finder.querySelector('[data-finder-next]');
      const resultsButton = finder.querySelector('[data-finder-results]');
      const panel = finder.querySelector('[data-finder-results-panel]');
      const resultGrid = finder.querySelector('[data-result-grid]');
      const error = finder.querySelector('[data-step-error]');
      const progressText = finder.querySelector('[data-progress-text]');
      const progressBar = finder.querySelector('[data-progress-bar]');
      const restart = finder.querySelector('[data-finder-restart]');
      const copyButton = finder.querySelector('[data-copy-results]');
      const copyStatus = finder.querySelector('[data-copy-status]');
      const noResults = finder.querySelector('[data-no-results]');
      let current = 0;
      let started = false;

      const showStep = (index) => {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === current));
        const label = finder.dataset.stepLabel.replace('CURRENT', String(current + 1)).replace('TOTAL', String(steps.length));
        progressText.textContent = label;
        progressBar.style.width = `${((current + 1) / steps.length) * 100}%`;
        back.hidden = current === 0;
        next.hidden = current === steps.length - 1;
        resultsButton.hidden = current !== steps.length - 1;
        error.hidden = true;
        steps[current].querySelector('input')?.focus({ preventScroll: true });
      };

      const currentIsValid = () => {
        const step = steps[current];
        if (step.hasAttribute('data-optional-step')) return true;
        return Boolean(step.querySelector('input:checked'));
      };

      const answer = (name) => form.querySelector(`[name="${name}"]:checked`)?.value || '';

      const showResults = () => {
        const selections = {
          age: answer('age'),
          weight: answer('weight'),
          style: answer('style'),
          goal: answer('goal'),
          fat: answer('fat'),
          exclusions: [...form.querySelectorAll('[name="exclusions"]:checked')].map((input) => input.value),
        };

        const ageInWeeks = {
          under_8: 0,
          '8_11': 8,
          '12_15': 12,
          '16_23': 16,
          '24_plus': 24,
        }[selections.age] ?? 0;

        const ranked = [...finder.querySelectorAll('[data-candidate]')]
          .map((card, index) => {
            const originalIndex = Number(card.dataset.originalIndex ?? index);
            card.dataset.originalIndex = String(originalIndex);
            const styles = list(card.dataset.chewStyles);
            const goals = list(card.dataset.goals);
            const proteins = list(card.dataset.proteins);
            const fatPercentage = Number.parseFloat(card.dataset.fatPct);
            const fatKnown = Number.isFinite(fatPercentage);
            const matchesAge = ageInWeeks >= Number(card.dataset.minAge);
            const matchesSize = list(card.dataset.dogSizes).includes(selections.weight);
            const excludedProtein = list(card.dataset.proteins).some((protein) => selections.exclusions.includes(protein));
            const matchesFat = selections.fat === 'yes'
              ? fatKnown && fatPercentage <= 10
              : selections.fat === 'unsure'
                ? !fatKnown || fatPercentage <= 20
                : true;
            const safetyRoute = selections.age === 'under_8' || selections.style === 'bite_down';
            const eligible = matchesAge && matchesSize && !excludedProtein && matchesFat && !safetyRoute;
            let score = card.dataset.evidenceGrade === 'A' ? 3 : 1;
            score += styles.includes(selections.style) ? 7 : -4;
            score += goals.includes(selections.goal) ? 8 : -3;
            if (selections.fat === 'yes' && fatKnown) score += Math.max(0, 10 - fatPercentage) / 2;
            if (selections.fat === 'unsure') score += fatKnown && fatPercentage <= 10 ? 2 : fatKnown ? 0 : -2;
            if (selections.weight === 'medium' && card.querySelector('.chew-finder__variant')?.textContent.toLowerCase().includes('medium')) score += 1;
            return { card, eligible, score, proteins, index: originalIndex };
          })
          .filter((item) => item.eligible)
          .sort((a, b) => b.score - a.score || a.index - b.index);

        const productsSeen = new Set();
        const deduplicated = ranked.filter((item) => {
          const handle = item.card.dataset.handle;
          if (productsSeen.has(handle)) return false;
          productsSeen.add(handle);
          return true;
        });

        const bestMatches = [];
        const bestProteins = new Set();
        deduplicated.forEach((item) => {
          if (bestMatches.length >= 3) return;
          const primaryProtein = item.proteins[0] || '';
          if (!bestProteins.has(primaryProtein)) {
            bestMatches.push(item);
            bestProteins.add(primaryProtein);
          }
        });
        deduplicated.forEach((item) => {
          if (bestMatches.length < 3 && !bestMatches.includes(item)) bestMatches.push(item);
        });

        const candidates = [
          ...bestMatches,
          ...deduplicated.filter((item) => !bestMatches.includes(item)).slice(0, Math.max(0, 6 - bestMatches.length)),
        ];

        finder.querySelectorAll('[data-candidate]').forEach((card) => {
          card.hidden = true;
          card.querySelector('[data-result-link]')?.setAttribute('tabindex', '-1');
        });

        candidates.forEach(({ card }, candidateIndex) => {
          card.hidden = false;
          card.querySelector('[data-result-link]')?.removeAttribute('tabindex');
          const matchLabel = card.querySelector('[data-match-label]');
          if (matchLabel) matchLabel.textContent = candidateIndex < 3 ? finder.dataset.resultBest : finder.dataset.resultAlso;
          resultGrid?.append(card);
        });

        noResults.hidden = candidates.length !== 0;
        const noResultsText = noResults.querySelector('p');
        if (noResultsText) {
          noResultsText.textContent = selections.age === 'under_8'
            ? finder.dataset.noResultsYoung
            : selections.style === 'bite_down'
              ? finder.dataset.noResultsDental
              : finder.dataset.noResultsDefault;
        }
        form.hidden = true;
        panel.hidden = false;
        panel.focus();
        emit(finder, 'finder_result', {
          result_handles: candidates.map(({ card }) => card.dataset.handle).join(','),
          result_count: candidates.length,
        });
      };

      start.addEventListener('click', () => {
        finder.classList.add('is-started');
        started = true;
        showStep(0);
        emit(finder, 'finder_start');
      });

      next.addEventListener('click', () => {
        if (!currentIsValid()) {
          error.hidden = false;
          error.focus?.();
          return;
        }
        emit(finder, 'finder_answer', { step: current + 1 });
        showStep(current + 1);
      });

      back.addEventListener('click', () => showStep(current - 1));

      resultsButton.addEventListener('click', () => {
        if (!currentIsValid()) {
          error.hidden = false;
          return;
        }
        emit(finder, 'finder_answer', { step: current + 1 });
        showResults();
      });

      restart.addEventListener('click', () => {
        form.reset();
        form.hidden = false;
        panel.hidden = true;
        copyStatus.textContent = '';
        showStep(0);
        emit(finder, 'finder_restart');
      });

      copyButton?.addEventListener('click', async () => {
        const titles = [...finder.querySelectorAll('[data-candidate]:not([hidden]) h3')].map((heading) => heading.textContent.trim());
        const text = `${finder.dataset.resultPrefix}\n${titles.map((title, index) => `${index + 1}. ${title}`).join('\n')}`;
        try {
          await navigator.clipboard.writeText(text);
          copyStatus.textContent = finder.dataset.copyConfirmed;
          emit(finder, 'finder_copy_results');
        } catch {
          copyStatus.textContent = finder.dataset.copyFailed;
        }
      });

      finder.addEventListener('click', (event) => {
        const link = event.target.closest('[data-candidate] a');
        if (link) emit(finder, 'finder_product_click', { handle: link.closest('[data-candidate]').dataset.handle });
      });

      if (!started) showStep(0);
    };

    const initialiseAll = () => document.querySelectorAll('[data-chew-finder]').forEach(initialise);
    initialiseAll();
    document.addEventListener('shopify:section:load', initialiseAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["codex-product-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('codex-cross-sell')) return;

    customElements.define('codex-cross-sell', class CodexCrossSell extends HTMLElement {
      connectedCallback() {
        this.bind();
        if (this.querySelector('[data-pairs-grid]')) {
          this.hidden = false;
          this.trackImpressions();
          return;
        }
        if (this.dataset.loading === 'true') return;
        this.dataset.loading = 'true';
        this.load();
      }

      async load() {
        if (!this.dataset.url) return;
        try {
          const response = await fetch(this.dataset.url, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Recommendation request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.querySelector('codex-cross-sell [data-pairs-content]');
          if (!incoming || !incoming.querySelector('[data-pairs-grid]')) {
            this.hidden = true;
            return;
          }
          this.querySelector('[data-pairs-content]').innerHTML = incoming.innerHTML;
          this.hidden = false;
          this.trackImpressions();
        } catch (error) {
          this.hidden = true;
        }
      }

      bind() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.addEventListener('change', event => {
          if (!event.target.matches('[data-pairs-variant]')) return;
          const item = event.target.closest('[data-pairs-item]');
          const price = item?.querySelector('[data-pairs-price]');
          const selected = event.target.selectedOptions?.[0];
          if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
        });

        this.addEventListener('click', event => {
          const link = event.target.closest('[data-pairs-link]');
          if (link) this.track('cc_pairs_product_click', link.closest('[data-pairs-item]'));

          const button = event.target.closest('[data-pairs-add]');
          if (!button) return;
          event.preventDefault();
          this.addItem(button);
        });
      }

      trackImpressions() {
        if (this.dataset.impressionsTracked === 'true') return;
        this.dataset.impressionsTracked = 'true';
        this.querySelectorAll('[data-pairs-item]').forEach(item => this.track('cc_pairs_impression', item));
      }

      track(eventName, item, extra = {}) {
        if (!item) return;
        const recommendationType = item.closest('[data-pairs-grid]')?.dataset.recommendationType || 'complementary';
        const detail = {
          event: eventName,
          recommendation_surface: this.dataset.source,
          recommendation_type: recommendationType,
          parent_product_id: Number(this.dataset.parentProductId),
          parent_product_handle: this.dataset.parentHandle,
          recommended_product_id: Number(item.dataset.productId),
          recommended_product_handle: item.dataset.productHandle,
          recommended_product_title: item.dataset.productTitle,
          ...extra
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(detail);
        document.dispatchEvent(new CustomEvent(`cc:${eventName}`, { detail }));
      }

      getVariant(item) {
        const field = item?.querySelector('[data-pairs-variant]');
        if (!field) return null;
        const option = field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
        if (!option?.value) return null;
        return {
          id: Number(option.value),
          title: option.dataset.variantTitle || ''
        };
      }

      async addItem(button) {
        const item = button.closest('[data-pairs-item]');
        const variant = this.getVariant(item);
        const recommendationType = item?.closest('[data-pairs-grid]')?.dataset.recommendationType || 'complementary';
        const message = item?.querySelector('[data-pairs-message]');
        if (!variant?.id || !item) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (message) {
          message.textContent = '';
          message.classList.remove('is-error');
        }
        this.track('cc_pairs_add_click', item, { recommended_variant_id: variant.id, recommended_variant_title: variant.title });

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variant.id,
                quantity: 1,
                properties: {
                  _cc_source: this.dataset.source,
                  _cc_parent_product: this.dataset.parentHandle,
                  _cc_recommendation_type: recommendationType
                }
              }]
            })
          });
          if (!response.ok) throw new Error('Cart request failed');

          button.textContent = button.dataset.addedLabel;
          this.track('cc_pairs_add_to_cart', item, { recommended_variant_id: variant.id, recommended_variant_title: variant.title });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          window.setTimeout(() => {
            button.textContent = button.dataset.defaultLabel;
          }, 1800);
        } catch (error) {
          if (message) {
            message.textContent = message.dataset.errorMessage;
            message.classList.add('is-error');
          }
          this.track('cc_pairs_add_failed', item, { recommended_variant_id: variant.id, recommended_variant_title: variant.title });
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
